<oph-chip-button (buttonClick)="addSked.emit()" *userHasRoleOption="rolePermissionOptions.Schedule">
  Add Sked
</oph-chip-button>

@for (sked of skeds; track sked) {
  <div class="item sked">{{ sked }}</div>
}
